/* Keystone Supply Group: licensed-facility attestation for Rx and IV products (Oct 1, 2026, Kevin; text shortened and scope widened to rx-only and cat:iv-infusion Oct 16, 2026).
   Loaded on product pages tagged license-attest (window.KSG_ATTEST). Add to cart and Buy it now stay disabled until the box is checked,
   and the order line carries the property "Licensed healthcare facility attestation: Yes". Sterile water and every other product are sold without it. */
(function () {
  if (!window.KSG_ATTEST) return;
  var TEXT = "I certify that I am purchasing for a licensed healthcare facility or a licensed practitioner.";
  function init() {
    // only the product's own form: skip product-card quick-add forms and the installment widget form.
    // Hyper's form carries <input name="id">, which shadows form.id, so ids go through get/setAttribute.
    var forms = Array.prototype.filter.call(document.querySelectorAll('form[action*="/cart/add"]'), function (f) {
      return !f.closest('[class*="product-card"]') && !/installment/.test(f.className || "");
    });
    forms.forEach(function (f, n) {
      if (f.getAttribute("data-ksg-attest")) return; f.setAttribute("data-ksg-attest", "1");
      var fid = f.getAttribute("id"); if (!fid) { fid = "ksg-attest-form-" + n; f.setAttribute("id", fid); }
      var btns = Array.prototype.slice.call(f.querySelectorAll('button[name="add"], button[type="submit"]'))
        .concat(Array.prototype.slice.call(document.querySelectorAll('button[form="' + fid + '"]')));
      if (!btns.length) return;
      var pay = Array.prototype.slice.call(document.querySelectorAll(".shopify-payment-button, .product-form__buttons .dynamic-checkout"));
      var w = document.createElement("div"); w.className = "ksg-attest";
      var id = "ksg-attest-" + n;
      w.innerHTML = '<label for="' + id + '"><input type="checkbox" id="' + id + '"><span>' + TEXT + '</span></label>' +
        '<p class="ksg-attest-err" role="alert" hidden>Check the box to confirm the purchase is for a licensed facility or practitioner.</p>';
      var hid = document.createElement("input"); hid.type = "hidden"; hid.name = "properties[Licensed healthcare facility attestation]"; hid.value = "Yes"; hid.disabled = true; hid.setAttribute("form", fid);
      w.appendChild(hid);
      var anchor = f.querySelector('button[name="add"], button[type="submit"]') || btns[0];
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(w, anchor); else f.appendChild(w);
      var cb = w.querySelector('input[type="checkbox"]'), err = w.querySelector(".ksg-attest-err");
      function sync() {
        hid.disabled = !cb.checked;
        btns.forEach(function (b) { b.disabled = !cb.checked; b.setAttribute("aria-disabled", cb.checked ? "false" : "true"); });
        pay.forEach(function (p) { p.style.display = cb.checked ? "" : "none"; });
        if (cb.checked) err.hidden = true;
      }
      cb.addEventListener("change", sync); sync();
      f.addEventListener("submit", function (e) { if (!cb.checked) { e.preventDefault(); e.stopImmediatePropagation(); err.hidden = false; cb.focus(); } }, true);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
